module.exports = __webpack_public_path__ + "static/Josephine-05e2dfa7e4c77c54fdb410bdf0555435.png";